module.exports = __webpack_public_path__ + "static/media/LeaveBwd.98d8fc91.svg";